import {initJCFSelect} from "./initJCFSelect";

export function hbsptFormInputAnimation() {
    window.initCustomSelect = function () {
        initJCFSelect();
    };

    window.addEventListener("load", () => {
        setTimeout(() => {
            $('.hbspt-form .input').append('<span class="for-validate"></span>');
        }, 100);
        $('.hbspt-form input, textarea').focus(function () {
            $(this).closest('.input').addClass('focused');
        }).blur(function () {
            $(this).closest('.input').removeClass('focused');
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hbsptFormInputAnimation.js